import React, { ChangeEvent, CSSProperties } from "react"
import { Form } from "react-bootstrap"
import { FormCheckType } from "react-bootstrap/esm/FormCheck"

const CheckBoxInput: React.FC<{
  checkBoxBtnList: Array<{ value: any; name: string }>
  isVertical?: boolean
  disabled?: boolean
  type?: FormCheckType
  checkBoxTitle?: string
  selectedValue: any[]
  setSelectedValue: React.Dispatch<React.SetStateAction<any[]>>
  name?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>, newSelectedValue: any[]) => any
}> = ({
  checkBoxBtnList,
  type = "checkbox",
  isVertical,
  disabled,
  checkBoxTitle,
  selectedValue,
  setSelectedValue,
  name,
  onChange,
}) => {
  // ループ処理でコンポーネント作成
  const チェックボックス一覧 = checkBoxBtnList.map((v, index, arr) => {
    const style: CSSProperties = {
      alignItems: "center",
      width: "max-content",
      marginLeft: isVertical ? undefined : "20px",
      margin: isVertical ? "10px 0 10px" : undefined,
    }
    if (index === 0 && isVertical) {
      style.margin = "0 0 10px"
    }
    return (
      <div key={index} style={style}>
        <Form.Check
          id={`${name}_${index}`}
          type={type}
          label={v.name}
          key={index}
          value={v.value}
          checked={selectedValue.includes(v.value)}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const index = selectedValue.findIndex((a) => a === v.value)
            if (index !== -1) {
              selectedValue.splice(index, 1)
            } else {
              selectedValue.push(v.value)
            }
            setSelectedValue([...selectedValue])
            onChange != null && onChange(e, selectedValue)
          }}></Form.Check>
      </div>
    )
  })

  return (
    <div
      style={{
        display: isVertical ? "block" : "flex",
        alignItems: "center",
        height: "100%",
      }}>
      {/* ループしてチェックボックスを作成する */}
      {checkBoxTitle && (
        <label style={{ display: "flex", alignItems: "center", margin: "0" }}>
          {checkBoxTitle}
        </label>
      )}
      {チェックボックス一覧}
    </div>
  )
}

export default CheckBoxInput
